import {$KTM, KeyMetadatas, $KTS, KeyTextStrings} from "../common/keytext";
import * as consts from "../consts";
import {Locale} from "../common/locales";

export enum AppType {
  DENTWYZE = "dentwyze",
  DOCWYZE = "docwyze",
}

type AppTypeMetadata = {
  name: string,
  domainName: string,
  userMailDomainName: string,
  serviceMailDomainName: string,
  localeDomainName: any,
  tagline: string,
}

export const APP_TYPE_METADATAS = new KeyMetadatas<AppTypeMetadata>([
  $KTM(AppType.DENTWYZE, {
    name: "Dentwyze",
    domainName: "dentwyze.com",
    userMailDomainName: "usermail.dentwyze.net",
    serviceMailDomainName: "servicemail.dentwyze.net",
    localeDomainName: {
      [Locale.EN_IN]: "dentwyze.in",
    },
    tagline: "Book your next appointment faster",
  }),
  $KTM(AppType.DOCWYZE, {
    name: "Docwyze",
    domainName: "docwyze.com",
    userMailDomainName: "usermail.docwyze.net",
    serviceMailDomainName: "servicemail.docwyze.net",
    localeDomainName: {
      [Locale.EN_IN]: "docwyze.in",
    },
    tagline: "Book your next appointment faster",
  }),
])


export const getProvisionedAppId = consts.getProvisionedAppId;

export const appType = getProvisionedAppId() as AppType;

export type AppTypeObject<T> = {
  docwyze: T,
  dentwyze: T,
}

export function appTypeObject<T>(object: AppTypeObject<T>): T {
  switch (appType) {
    case AppType.DENTWYZE:
      return object.dentwyze as T;
    case AppType.DOCWYZE:
      return object.docwyze as T;
  }
  return null;
}

export function appNameString(): string {
  return APP_TYPE_METADATAS.findMetadata(appType)?.name;
}

export function appDomainNameString(locale?: Locale): string {
  const metadata = APP_TYPE_METADATAS.findMetadata(appType);
  if (!metadata) {
    return null;
  }
  return (locale && metadata.localeDomainName[locale]) || metadata.domainName;
}

export function userMailDomainNameString(): string {
  const metadata = APP_TYPE_METADATAS.findMetadata(appType);
  if (!metadata) {
    return null;
  }
  return metadata.userMailDomainName;
}

export function serviceMailDomainNameString(): string {
  const metadata = APP_TYPE_METADATAS.findMetadata(appType);
  if (!metadata) {
    return null;
  }
  return metadata.serviceMailDomainName;
}

export function appTagline(): string {
  return APP_TYPE_METADATAS.findMetadata(appType)?.tagline;
}

export enum DeviceModel {
  CHECKIN_R1 = "checkin_r1",
}

export enum DeviceOrientation {
  LANDSCAPE = "landscape",
  PORTRAIT = "portrait",
  LANDSCAPE_R = "landscape-r",
  PORTRAIT_R = "portrait-r",
}

export const DEVICE_ORIENTATION_KTS = new KeyTextStrings([
  $KTS(DeviceOrientation.LANDSCAPE, "Landscape"),
  $KTS(DeviceOrientation.PORTRAIT, "Portrait"),
  $KTS(DeviceOrientation.LANDSCAPE_R, "Landscape Reversed"),
  $KTS(DeviceOrientation.PORTRAIT_R, "Portrait Reversed"),
]);

export type DeviceModelInfo = {
  name: string,
  releaseYear: string,
  orientations: DeviceOrientation[],
}

export const DEVICE_MODEL_INFO_KTM = new KeyMetadatas<DeviceModelInfo>([
  $KTM(DeviceModel.CHECKIN_R1, {
    name: "Check-in R1",
    releaseYear: "2026",
    orientations: [DeviceOrientation.LANDSCAPE, DeviceOrientation.PORTRAIT],
  }),
]);

